import { Stack } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { InvestorCommunicationInfo } from "../../../api/types/investorCommunicationsTypes";
import InvestorCommunicationTypeAvatar from "./InvestorCommunicationTypeAvatar";

interface Props {
  communication: InvestorCommunicationInfo;
}

const InvestorCommunicationTitleCell = ({ communication }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center", minWidth: 0 }}>
    <InvestorCommunicationTypeAvatar type={communication.type} />
    <TypographyTooltipEllipsis text={communication.title || "Untitled"} />
  </Stack>
);

export default InvestorCommunicationTitleCell;
